var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4"}},[_c('v-card',[_c('v-card-text',[_vm._v("Para começar, selecione a opção desejada no menu ao lado")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }